import { render, staticRenderFns } from "./Competicao.vue?vue&type=template&id=be0e01d8&scoped=true&"
import script from "./Competicao.vue?vue&type=script&lang=ts&"
export * from "./Competicao.vue?vue&type=script&lang=ts&"
import style0 from "./Competicao.vue?vue&type=style&index=0&id=be0e01d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0e01d8",
  null
  
)

export default component.exports